export default function Exchanges() {
    return (
        <>
            <div class="section-header justify-content-between align-items-center mb-3">
                <h4 class="mb-1 fw-bold">Exchanges</h4>
                <small class="text-muted">
                    Connect with exchanges
                </small>
            </div>
            <main class="">
                Coming Soon...
            </main>
        </>
    )
}